export const productApi = '/api/v1/store/product';
